var _a;
import { loadWindowEnv } from './window-env';
export var config = (_a = loadWindowEnv(), _a.config), accounts = _a.accounts, amazonCognito = _a.amazonCognito;
//# sourceMappingURL=frontend-config.js.map